import { useMatch, useSearchParams } from 'react-router';

import { useGetRecap, useGetVersion } from '@/api/generated/recaps.ts';

// What the recap's page shows (plan/DECISIONS.md D107): at its URL the published version, or the one `?version=<number>`
// picks, read-only; at /draft its rows, which are the draft, read-only, and at /edit to edit. A recap never published
// shows its rows at its URL too. The page and its crumb read it, so they name the same.
const useShownRecap = (publicId: string) => {
    const isDraftMode = useMatch('/w/:workspaceSlug/recaps/:recapRef/draft') !== null;
    const isEditMode = useMatch('/w/:workspaceSlug/recaps/:recapRef/edit') !== null;
    const [searchParams] = useSearchParams();
    const recap = useGetRecap(publicId);
    const pickedNumber = Number(searchParams.get('version')) || null;
    const publishedNumber = recap.data?.published_version?.number ?? null;
    const shownNumber = isDraftMode || isEditMode ? null : (pickedNumber ?? publishedNumber);
    const version = useGetVersion(shownNumber === null ? null : publicId, shownNumber);

    return { recap, version, shownNumber, pickedNumber, isDraftMode, isEditMode };
};

export default useShownRecap;
